import {
    BookmarkBorderRounded,
    EditOutlined,
    SystemUpdateAlt,
    ThumbUpOutlined,
} from '@mui/icons-material';

import './SignedOutLibraryFeatures.css';

const FEATURES = [
    {
        title: 'Save episodes',
        description: 'Listen when you’re ready.',
        Icon: BookmarkBorderRounded,
    },
    {
        title: 'Follow people and shows',
        description: 'Keep up with new episodes.',
        Icon: ThumbUpOutlined,
    },
    {
        title: 'Take notes',
        description: 'Capture ideas as you listen.',
        Icon: EditOutlined,
    },
    {
        title: 'Import your shows',
        description: 'Bring your favorites from any app.',
        Icon: SystemUpdateAlt,
    },
];

const SignedOutLibraryFeatures = () => (
    <ul className='signedOutLibraryFeatures' aria-label='Library features'>
        {FEATURES.map(({ title, description, Icon }) => (
            <li className='libraryFeatureRow' key={title}>
                <span className='libraryFeatureIcon' aria-hidden='true'>
                    <Icon />
                </span>
                <div className='libraryFeatureCopy'>
                    <h2>{title}</h2>
                    <p>{description}</p>
                </div>
            </li>
        ))}
    </ul>
);

export default SignedOutLibraryFeatures;
